/* Keep native variant photographs and the reviewed carousel in sync. */
(() => {
  const picker=document.getElementById('product-variant');
  const hero=document.getElementById('main-photo');
  if(!picker||!hero)return;
  function update(){
    const item=window.MDM_PRODUCT_CATALOG?.[picker.value];
    if(!item?.image)return;
    const source=new URL(item.image,window.location.href).href;
    const thumbs=document.querySelector('.generic-gallery .thumbs');
    if(thumbs){
      let thumb=Array.from(thumbs.querySelectorAll('.thumb')).find(button=>new URL(button.dataset.photo,window.location.href).href===source);
      if(!thumb){
        thumb=document.createElement('button');thumb.type='button';thumb.className='thumb';thumb.dataset.photo=source;thumb.dataset.alt=item.name+(item.detail?' · '+item.detail:'');thumb.setAttribute('aria-label','Voir la variante sélectionnée');thumb.setAttribute('aria-pressed','false');
        const image=document.createElement('img');image.src=source;image.alt=thumb.dataset.alt;image.width=140;image.height=140;image.loading='lazy';thumb.append(image);thumbs.append(thumb);
      }
      thumb.click();
    }else{hero.src=source;hero.alt=item.name+(item.detail?' · '+item.detail:'');}
  }
  picker.addEventListener('change',update);update();
})();